import React, { PropTypes } from 'react';
import { Link, hashHistory } from 'react-router'
import DataService from '../../lib/DataService';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import SharedTools from '../../lib/SharedTools';
import { Select, InputNumber, Modal, message } from 'antd';

const Option = Select.Option;


export default class ArchiveProcessIndexPage extends React.Component {

  constructor(props) {
    super(props);
    // set state

    let currentSemester = SharedTools.getCurrentSemester();
    // let semesters = SharedTools.getAllSemesters(currentSemester, 20171);
    this.state = {
      currentRole: CurrentRoleStore.getCurrentRole(),
      grades: [],
      graduatedArray: [],
      showGraduated: false,
      schoolId: this.props.params.schoolId,

      currentSemester,
      semester: currentSemester,
      semesters: [],

      graduatedArray: [],
    };
    // bind this
    this.onCurrentRoleChange = this.onCurrentRoleChange.bind(this);
    this.toolGraduatedDate = this.toolGraduatedDate.bind(this);
  }

  componentWillMount() {
    // let data = {
    //   school_id: this.state.schoolId,
    //   info: 'template',
    //   semester: this.state.semester
    // }
    // this.loadClasses(data)

    DataService.getSchoolInfo(this.state.schoolId).then((school) => {
      let currentSemester = this.state.currentSemester
      if (school && school.archive_semester_count == 1) {
        let year = this.state.currentSemester.toString().split('').slice(0, 4).join('');
        currentSemester = Number(year + '1');
      }
      let semesters = SharedTools.getAllSemesters(currentSemester, 20201, school.archive_semester_count)

      this.setState({
        semester: currentSemester,
        semesters,
        currentSemester
      })

      let data = {
        school_id: this.state.schoolId,
        info: 'statistic_template',
        semester: currentSemester
      }
      this.loadClasses(data)

    }).catch((error) => {
      console.log(error);
    });
  }

  loadClasses(data) {
    DataService.getClassList(data).then(res => {
      let grades = [];
      res.map(classItem => {
        if (this.state.currentRole.associatName == 'school' || this.state.currentRole.associatName == 'system' || this.state.currentRole.associatName == 'classGrade' && !classItem.is_deleted) {
          let index = grades.findIndex((grade) => grade.id == classItem.class_grade_id);
          if (index >= 0) {
            grades[index].classes.push(classItem);
          } else {
            grades.push({
              id: classItem.class_grade_id,
              name: classItem.grade_name,
              classes: [classItem],
              is_graduated: classItem.is_graduated,
              graduate_date: classItem.graduate_date
            })
          }
        }
        if (this.state.currentRole.associatName == 'classGrade') {
          grades = grades.filter((grade) => grade.id == this.state.currentRole.associatObj.id);
        }
      })
      let graduatedArray = grades.filter((grade) => {
        let time = new Date("2021-09-01").getTime();
        if (grade.is_graduated && grade.graduate_date && (new Date(grade.graduate_date).getTime() > time)) {
          return true
        }
      
      })
      this.setState({
        grades: grades.filter((grade) => !grade.is_graduated),
        graduatedArray
      })
    });

  }

  componentDidMount() {
    CurrentRoleStore.addChangeListener(this.onCurrentRoleChange);
  }

  componentWillUnmount() {
    CurrentRoleStore.removeChangeListener(this.onCurrentRoleChange);
  }

  onCurrentRoleChange() {
    this.setState({
      currentRole: CurrentRoleStore.getCurrentRole()
    });
  }

  toolGraduatedDate(date) {
    return date ? (new Date(date).getFullYear() + '年') : ''
  }

  goSchoolArchiveSettingPage(gradeId, gradeName) {
    let { semester, schoolId } = this.state;
    hashHistory.push(`archive/archive-process/schools/${schoolId}/process-setting?semester=${semester}&gradeName=${gradeName}&gradeId=${gradeId}`);
  }

  selectSemester(value) {
    if (value != this.state.semester) {
      this.setState({
        semester: value,
      }, () => {
        let data = {
          school_id: this.state.schoolId,
          info: 'statistic_template',
          semester: value
        }
        this.loadClasses(data);
      })
    }
  }

  _selectSemesterBox() {
    return (
      <div className="select-semester-box">
        <Select value={String(this.state.semester)} style={{ width: 145 }} onChange={this.selectSemester.bind(this)}>
          {this.state.semesters.map((semester, index) => <Option value={String(semester.semester)} key={index}>{semester.semesterToString}</Option>)}
        </Select>
      </div>
    )
  }

  toolProcessDetail(process) {
    if (!process) {
      return 0
    }

    let str = (process * 100).toFixed(2).toString()

    return str.slice(0, str.length - 1) + '%'
  }

  render() {
    return (
      <div className="archive-content-setting-index-page archive-content-setting-class-page">
        {this._selectSemesterBox()}
        <div className="grades-list">
          {this.state.grades.map(grade => {
            return <div className="grade-box" key={"grade-" + grade.id}>
              <div className="grade-name">
                {grade.name}
                {this.state.currentRole.associatName == 'system' ? <a className="add-label" onClick={this.goSchoolArchiveSettingPage.bind(this, grade.id, grade.name)}>编辑档案配置</a> : ''}
              </div>
              {grade.classes.map((classItem, classIndex) => {
                return <div className="class-box" key={"class-" + classItem.id}>
                  <Link to={`archive/archive-process/schools/${this.props.params.schoolId}/classes/${classItem.id}?semester=${this.state.semester}&ratio=${classItem.ratio}&className=${classItem.name}`}>
                    <div className="class-content">
                      <div className="text-bg">{classItem.name}</div>
                      <div className="text-sm">配置数量：{classItem.page_count}</div>
                      <div className="text-sm">完成情况：{this.toolProcessDetail(classItem.ratio)}</div>
                    </div>
                  </Link>
                </div>
              })}
            </div>
          })}
          <div style={{ color: '#4DA1FF', marginBottom: '20px', cursor: 'pointer' }} onClick={() => this.setState({ showGraduated: !this.state.showGraduated })}>{this.state.showGraduated ? '收起' : '查看'}毕业班级</div>
          {this.state.showGraduated && this.state.graduatedArray.map(grade => {
            return <div className="grade-box" key={"grade-" + grade.id}>
              <div className="grade-name">{grade.name} - {this.toolGraduatedDate(grade.graduate_date)}毕业</div>
              {grade.classes.map((classItem, classIndex) => {
                return <div className="class-box" key={"class-" + classItem.id}>
                  <Link to={`archive/archive-process/schools/${this.props.params.schoolId}/classes/${classItem.id}?semester=${this.state.semester}&ratio=${this.toolProcessDetail(classItem.ratio)}`}>
                    <div className="class-content">
                      <div className="text-bg">{classItem.name}</div>
                      <div className="text-sm">配置数量：{classItem.page_count}</div>
                      <div className="text-sm">完成情况：{classItem.ratio}</div>
                    </div>
                  </Link>
                </div>
              })}
            </div>
          })}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/process/ArchiveProcessIndexPage.jsx